var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 150,
    viewBox: "0 0 141 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2715 95L48 75.7755L53.4054 70.3832L67.2896 84.2335L96.5946 55L102 60.3922L67.2715 95L67.2715 95Z",
    fill: "#57B894"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5965 126.076C67.0635 126.076 59.9757 124.524 53.5831 121.675L30.8173 135.641C43.1316 144.668 58.2797 150 74.5965 150C103.06 150 127.603 133.976 140.25 110.279L119.82 99.1632C111.315 115.441 94.304 126.076 74.5965 126.076ZM23.5459 75.0811C23.5459 46.0518 46.1215 23.6251 74.7427 23.6251C94.4063 23.6251 111.379 34.1287 119.866 50.2037L140.25 39.2269C127.632 15.8256 103.142 0 74.7427 0C33.5032 0 0 33.6273 0 75.0811C0 99.151 11.314 120.576 28.8694 134.31L35.9428 109.013C28.177 100.042 23.5459 88.2308 23.5459 75.0811Z",
    fill: "#57B894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerified);
export default __webpack_public_path__ + "static/media/email-verified.6b5a0b9f0d2c158cec256c479ae638a1.svg";
export { ForwardRef as ReactComponent };